import { jsxs as I, jsx as t } from "react/jsx-runtime";
import { RocheUITextLink as i } from "../text-link/roche-text-link.js";
import { RocheUITextLinkType as l } from "../text-link/roche-text-link.types.js";
import e from "./roche-contact-person.module.scss.js";
import { RocheUIContactPersonLayout as c } from "./roche-contact-person.types.js";
const v = ({
  layout: a = c.VARIANT_A,
  name: m,
  jobTitle: p,
  phoneNumber: o,
  phoneVisuallyHiddenText: _,
  emailAddress: n,
  emailVisuallyHiddenText: h,
  children: s,
  slot: T
}) => {
  const r = a !== c.VARIANT_B, d = a !== c.VARIANT_A_WITHOUT_IMAGE && s;
  return /* @__PURE__ */ I("div", { className: e["contact-person"], slot: T, children: [
    d && /* @__PURE__ */ t("div", { className: e["contact-person__avatar"], children: s }),
    /* @__PURE__ */ t("h3", { className: e["contact-person__name"], children: m }),
    /* @__PURE__ */ t("p", { className: e["contact-person__job-title"], children: p }),
    r && o && /* @__PURE__ */ t("div", { className: e["contact-person__phone-number"], children: /* @__PURE__ */ t(
      i,
      {
        href: `tel:${o}`,
        text: o,
        visuallyHiddenText: _,
        leftIcon: "phone",
        type: l.CONTACT_PERSON
      },
      "phone-number"
    ) }),
    r && n && /* @__PURE__ */ t("div", { className: e["contact-person__email-address"], children: /* @__PURE__ */ t(
      i,
      {
        href: `mailto:${n}`,
        text: n,
        visuallyHiddenText: h,
        leftIcon: "email",
        type: l.CONTACT_PERSON
      },
      "email-address"
    ) })
  ] });
};
export {
  v as RocheUIContactPerson
};
